import React, { Fragment } from "react";
import PropTypes from "prop-types";

const InsuranceType = ({ criteria }) => {
  return (
    <Fragment>
      {/* Any Insurance Required (AIR) */}
      {!criteria.IsMedicareOnly &&
        !criteria.RequiresCommercialInsurance &&
        criteria.RequiresInsurance === 1 &&
        "Have health insurance that covers your qualifying medication or product."}

      {/* Medicare Not Allowed (MNA) */}
      {criteria.IsMedicareOnly === 0 &&
        !criteria.RequiresCommercialInsurance &&
        criteria.RequiresInsurance === 1 &&
        "Have health insurance other than Medicare that covers your qualifying medication or product."}

      {/* Medicare Only (MONLY) */}
      {criteria.IsMedicareOnly === 1 &&
        !criteria.RequiresCommercialInsurance &&
        criteria.RequiresInsurance === 1 &&
        "Have Medicare health insurance that covers your qualifying medication or product."}

      {/* Commercial Not Allowed (CNA) */}
      {!criteria.IsMedicareOnly &&
        criteria.RequiresCommercialInsurance === 0 &&
        criteria.RequiresInsurance === 1 &&
        "Have health insurance other than commercial health insurance that covers your qualifying medication or product."}

      {/* Commercial Only (CONLY) */}
      {!criteria.IsMedicareOnly &&
        criteria.RequiresCommercialInsurance === 1 &&
        criteria.RequiresInsurance === 1 &&
        "Have commercial health insurance that covers your qualifying medication or product."}

      {/* Only Commercial Insurance is Required (OCIR) */}
      {!criteria.IsMedicareOnly &&
        criteria.RequiresCommercialInsurance === 2 &&
        criteria.RequiresInsurance === 1 &&
        "Have commercial health insurance that covers your qualifying medication or product."}

      {/* Only Medicare is Required (OMR) */}
      {criteria.IsMedicareOnly === 2 &&
        !criteria.RequiresCommercialInsurance &&
        criteria.RequiresInsurance === 1 &&
        "Have Medicare health insurance that covers your qualifying medication or product."}

      {/* Both Commercial Insurance and Medicare Required (BCIMR) */}
      {criteria.IsMedicareOnly === 2 &&
        criteria.RequiresCommercialInsurance === 2 &&
        criteria.RequiresInsurance === 1 &&
        "Have both Medicare and commercial health insurance that covers your qualifying medication or product."}

      {/* No Insurance Required (NIR) */}
      {!criteria.IsMedicareOnly &&
        !criteria.RequiresCommercialInsurance &&
        !criteria.RequiresInsurance &&
        "There is no health insurance requirement."}
    </Fragment>
  );
};

InsuranceType.propTypes = {
  criteria: PropTypes.object.isRequired,
};

export default InsuranceType;
